import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Button, Table, message, Form, Modal, Select, Spin, Space, Row, Col} from 'antd';
import {Link, useNavigate} from "react-router-dom";
import {MdAddHome} from "react-icons/md";
import {
    AiFillAlert,
    AiFillDelete,
    AiFillEdit,
} from "react-icons/ai";
import {IoPersonSharp, IoReload} from "react-icons/io5";
import Search from "antd/es/input/Search";

const columns = [
    {
        title: 'Tipo de Ruta',
        dataIndex: 'denominacion',
    },{
        title: 'Descripción',
        dataIndex: 'descripcion',
    }
];

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});
const { Option } = Select;


const TipoRuta = () => {

    if(sessionStorage.getItem('user_mod'))
       sessionStorage.removeItem('user_mod');

    const [bottom, setBottom] = useState('bottomCenter');

    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);

    const [form] = Form.useForm();

    const navigate = useNavigate();

    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState("Cargando datos...");

    const [messageApi, contextHolder] = message.useMessage();

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading] = useState(false);

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    useEffect(() => {
        recargar();
    }, []);  

    const recargar = () => {
        setSpinTitle("Cargando datos...");
        setSpinning(true);
        setSelectedRowKeys([]);
        let aux = [];

        let start = 0;
        let limit = 1000;

        Axios.get(`ht/getCategoriaServicio?start=${start}&limit=${limit}`,
        {
            headers: headers
          })
            .then(response => {
                setSpinning(false);
                console.log('getCategoriaServicio', response.data);
                if(response.data.data.length>0){
                    for(var i=0;i<response.data.data.length;i++){
                        aux.push({
                            key:response.data.data[i].idcategoriaservicio,
                            idcategoriaservicio:response.data.data[i].idcategoriaservicio,
                            denominacion:response.data.data[i].denominacion,
                            descripcion:response.data.data[i].descripcion
                        });
                    }
                }

                setData(aux);
                setOriginal(aux);
            })
            .catch(error => {
                setSpinning(false);
            })
    };

    const getInfoForm = async (id) => {
        for(var i=0; i<data.length; i++){
            if(data[i].idcategoriaservicio === id){
                return data[i];
            }
        }
        return [];
    };

    const modificar = async () => {
        form.resetFields();
        const row = await getInfoForm(selectedRowKeys[0]);
        sessionStorage.setItem('user_mod', JSON.stringify(row));
    };

    const eliminar = (e) => {
        Modal.confirm({
            title: 'Eliminar datos!',
            cancelText:'Cancelar',
            okText:'Aceptar',
            okType:'primary',
            content: (
                <div>
                    <span >¿Desea eliminar los datos seleccionados?</span>
                </div>
            ),
            onOk() {
                setSpinTitle("Eliminando datos");
                setSpinning(true);
                Axios.delete('ht/deleteCategoriaServicio',
                    {
                      data: {
                        "idcategoriaservicio": selectedRowKeys
                      },
                      headers: headers
                    }
                ).then(response => {
                    setSpinning(false);
                    if(response.data.success){
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                        recargar();
                    }else{
                        messageApi.open({
                            type: 'error',
                            content: 'Error al eliminar los datos',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                    .catch(error => {
                        setSpinning(false);
                        messageApi.open({
                            type: 'error',
                            content: 'Error al eliminar los datos',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    });
            },
        });
    };

    const onSearch = (value, _e, info) => {
        filterLocal(value);
    };

    const filterLocal = (value) => {
        if(value === "" || value === null){
            setData(original);
        }else{
            var aux = [];
            original.forEach(function(option) {
                if (option.denominacion.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const selectRowUpdate  = async (record) => {
        setSelectedRowKeys([record.key]);
        form.resetFields();
        let row = [];
        for(let i=0;i<data.length;i++){
            if(data[i].idcategoriaservicio === record.key){
                row = data[i];
            }
        }
       
        sessionStorage.setItem('user_mod', JSON.stringify(row));
        navigate(`/edittiporuta/${record.key}`)
        
    };


    return (
        <Spin spinning={spinning} tip={spinTitle} size={"large"}>
        <div>
            {/*<h2 style={{textAlign:"center"}}>Características del transporte</h2>*/}
            <p style={{textAlign:"center", margin:0, fontSize:'20px', fontWeight:'bold'}}>Tipos de Ruta</p>
            {contextHolder}
            <div
                style={{
                    marginBottom: 10,
                }}
            >
                {contextHolder}
                <Space direction='horizontal'>
                    <Link to="/addtiporuta">
                        <Button type="primary" className="button" icon={<MdAddHome />} disabled={loading}>
                            Adicionar
                        </Button>
                    </Link>
                    <Link to={`/edittiporuta/${selectedRowKeys[0]}`}>
                        <Button type="primary" className="button" icon={<AiFillEdit />} onClick={modificar} disabled={loading || selectedRowKeys.length != 1}>
                            Modificar
                        </Button>
                    </Link>
                        <Button type="primary" danger className="button" icon={<AiFillDelete />} onClick={eliminar}
                                disabled={!hasSelected || loading}>
                            Eliminar
                        </Button>

                    <Button type="primary" className="button" icon={<IoReload />} onClick={recargar} loading={loading || loading}>
                        Recargar
                    </Button>

                    <Search
                        placeholder="Escriba el Tipo de Ruta"
                        enterButton
                        style={{
                            width: 220,
                        }}
                        size="middle"
                        onSearch={onSearch}
                        onChange={(e) => {
                            filterLocal(e.target.value);
                        }}
                    />
                </Space>
            </div>

            <Row>
                <Col span={24}>
                    <Table size="small"
                        // scroll={{
                        //     y: 350,
                        // }}
                        bordered={true}
                           pagination={{
                               position: [bottom],
                               pagination: {
                                   current: 1,
                                   pageSize: 10,
                               }}}
                           rowSelection={rowSelection}
                           columns={columns} dataSource={data}
                           onRow={(record) => {
                               return {
                                   onDoubleClick: async () => {
                                       selectRowUpdate(record);
                                   }
                               }
                           }}/>
                </Col>
            </Row>



         </div>
        </Spin>
    );
};
export default TipoRuta;